import React from "react"
import cogoToast from "cogo-toast"

export const successToastNotification = (message: string, options:any = {}) => {
  const { hide } = cogoToast.success(parseNewLineMessage(message), {
    ...options,
    onClick: () => {
      if (hide) {
        hide();
      }
    },
  });
}

export const warningToastNotification = (message: string, options:any = {}) => {
  const { hide } = cogoToast.warn(parseNewLineMessage(message), {
    ...options,
    onClick: () => {
      if (hide) {
        hide();
      }
    },
  });
}

export const errorToastNotification = (message: string, options:any = {}) => {
  const { hide } = cogoToast.error(parseNewLineMessage(message), {
    ...options,
    onClick: () => {
      if (hide) {
        hide();
      }
    },
  });
}

const parseNewLineMessage = (message: string) => {
  const splitMessage = message ? message.split("\n") : "";
  return splitMessage ? splitMessage.map((m, index) => (
    <span key={`${m}-${index}`}>
      {m}
      { (index !== (splitMessage.length - 1)) && <br />}
    </span>
  )) : ""
}
